import type { FC } from 'react'
import Icon from './Icon.tsx'
import { useTranslation } from 'react-i18next'

interface ToastProps {
  readonly message: string
  readonly onClose: () => void
}

export const Toast: FC<ToastProps> = ({ message, onClose }) => {
  const { t } = useTranslation()

  return (
    <div className="flex w-[400px] max-w-xs animate-slide-in flex-col items-center gap-1 rounded-lg bg-red-600 px-4 py-2 text-sm text-white">
      <div className="flex w-full items-center gap-2">
        <Icon name="warning" width={16} />
        <div className="mr-auto font-bold">{t('ls_error_unexpected')}</div>
        <button type="button" onClick={onClose}>
          <Icon name="xMark" width={20} />
        </button>
      </div>
      <div className="w-full">{t(message)}</div>
    </div>
  )
}
